import useSwr from "@/core/composables/swr/useSwr";
import {laboratoryApi} from "@/container";
import {computed} from "vue";

const useLaboratoryNeeds = (laboratoryId: string) => {
    const key = computed(() => {
        return laboratoryId && `/laboratories/${laboratoryId}/ranges/products/paginatedWithNeeds`;
    });

    const {data, isLoading, mutate} = useSwr(
        key,
        () => laboratoryApi().needs(Number(laboratoryId), 1, 50),
        {
            revalidateOnFocus: false
        }
    );
    return {
        data,
        isLoading,
        mutate
    };
};

export default useLaboratoryNeeds;
